/**
 * Balloon Events Map - Web Component Entry Point
 * 
 * Custom element for framework-agnostic usage
 * Auto-registers as <balloon-events-map> on import
 * 
 * @example
 * ```html
 * <!DOCTYPE html>
 * <html>
 * <head>
 *   <script type="module">
 *     import 'balloon-events-map/webcomponent';
 *   </script>
 * </head>
 * <body>
 *   <balloon-events-map 
 *     api-key="your-key"
 *     language="de"
 *     initial-lat="48.2082"
 *     initial-lng="16.3738">
 *   </balloon-events-map>
 *   
 *   <script>
 *     const map = document.querySelector('balloon-events-map');
 *     
 *     map.addEventListener('ready', (e) => {
 *       console.log('Map is ready!');
 *     });
 *     
 *     map.addEventListener('eventClick', (e) => {
 *       console.log('Event clicked:', e.detail);
 *     });
 *   </script>
 * </body>
 * </html>
 * ```
 * 
 * @packageDocumentation
 */

// Web Component class
export { BalloonEventsMapElement } from './webcomponent/BalloonEventsMapElement';

// Auto-register the custom element when this module is imported
import './webcomponent/BalloonEventsMapElement';

// Version
export const VERSION = '2.0.0';

// Note: Web Components don't typically have a default export
// since the main usage is through the custom element registration
